import React from 'react';
import './FaultFirstPage_Coral/FaultFirstPageCustom_Coral.css'
import DashboardMain_Coral from '../DashboardMain_Coral/DashboardMain_Coral';
import FaultFirstPageCharts_Coral from './FaultFirstPage_Coral/FaultFirstPageCharts_Coral';
import FaultFirstPageDataBars_Coral from './FaultFirstPage_Coral/FaultFirstPageDataBars_Coral';
import FaultFirstPageFilters_Coral from './FaultFirstPage_Coral/FaultFirstPageFilters_Coral';
import FaultFirstPageKpis_Coral from './FaultFirstPage_Coral/FaultFirstPageKpis_Coral';
import FaultFirstPageBarChart_Coral from './FaultFirstPage_Coral/FaultFirstPageBarChart_Coral';
import { useCallback, useContext, useEffect, useState } from "react";
import moment from 'moment';
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitialstates_coral';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitialstates_coral';
import useHttp from '../../../hook/use-http'
import AppContext from '../../../store/AppContext';
import Faultanalysis_Coral from './Faultanalysis_Coral';

export default function FaultPage_Coral() {
  const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE)
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);
  const log_data = (data) => {
  }

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "faultanalysis"
      }
    }, log_data)
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] }
    });
  }
  console.log('error');
  const onreset = (data) => {
    setGloablfilter(data);
  }

  if (gloablfilter.pageSelected === 1) {
    return (
      <>
        <DashboardMain_Coral>
          <FaultFirstPageFilters_Coral onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} />
          <div className="container-fluid">
            <FaultFirstPageKpis_Coral gloablfilter={gloablfilter} />
            <section className="graphs sec2Charts">
              <FaultFirstPageDataBars_Coral singleVinSelected={singleVinSelected} gloablfilter={gloablfilter} />
              <div className="row mt-4 mb-3">
                <FaultFirstPageCharts_Coral gloablfilter={gloablfilter} />
                <FaultFirstPageBarChart_Coral gloablfilter={gloablfilter} />
              </div>
            </section>
          </div>
        </DashboardMain_Coral>
      </>
    );
  } else {
    return (
      <DashboardMain_Coral>
        <Faultanalysis_Coral gloablfilter={gloablfilter} pageChange={pageChange} />
      </DashboardMain_Coral>
    );
  }
}